import { Molecule, wrap } from 'AppReact'
import styled from 'styled-components'
import { SecondaryTextSm } from 'atoms';
import Input from 'atoms/textInput';
import { Mt1 } from 'wrappers';

const template = styled.div`
`

export default Molecule({
  template,
  type: '',
  atoms: [
    {
      component: SecondaryTextSm,
      name: 'Label',
      displayValue: ({ label }) => label
    },
    {
      component: wrap(Input, Mt1),
      name: 'Input',
      bindings: ({ }) => ({})
    }
  ]
})